// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Alert, Stack, Text } from '@mantine/core';
import { useFormMetadata } from '../../../Service/Context/BookitupFormContext';

const RequiredFieldsAlert = () => {
  const { emailPresent, endDatePresent } = useFormMetadata();

  return (
    <Stack>
      <Alert hidden={emailPresent} sx={(theme) => ({ backgroundColor: theme.colors.red[4] })}>
        <Text color="white">
          Im Kontaktformular fehlt ein Feld für die Kunden E-Mail abzufragen. Dieses ist jedoch unbedingt notwendig.
          Füge es über die Seitenleiste hinzu.
        </Text>
      </Alert>
      <Alert hidden={!endDatePresent} sx={(theme) => ({ backgroundColor: theme.colors.orange[3] })}>
        <Text color="white">
          Eine Veranstaltung kann mit maximal sieben Terminen erstellt werden. Falls Sie mehr Termine hinzufügen
          möchten, kontaktieren Sie bitte unseren Support.
        </Text>
      </Alert>
    </Stack>
  );
};

export default RequiredFieldsAlert;
